export interface Release {
  version: string; // "2026.02.25"
  date: string; // "2026-02-25"
  items: string[];
}

export const releases: Release[] = [
  {
    version: "2026.02.25",
    date: "2026-02-25",
    items: [
      "テンプレート変数 {{staff_name_last}} を追加（担当者の姓のみ表示）",
      "担当者情報が基幹システムから自動同期されるようになりました",
      "送信時の担当者がログインユーザーで自動設定されるようになりました",
      "送信待ちメッセージのキャンセル機能を追加",
      "ヘルプツールチップの表示を改善",
    ],
  },
];
